import { DefaultError, useMutation, useQuery } from "@tanstack/react-query";
import { useQueryToast } from "hooks";
import i18next from "i18next";
import { apiClient } from "utils";
import { useResponseHandler } from "utils/service/responseHandler";
import { IGenerateEanResponse } from "./types";

export const useGetEanCount = (enabled?: boolean) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<number, DefaultError>({
    queryKey: ["count-available-eans"],
    async queryFn() {
      const response = await apiClient({
        method: "GET",
        url: `CodesDistributor/Ean/CountAvailable`,
      });

      return responseHandler(response, {
        groupName: `useGetEanCount`,
      });
    },
    enabled,
  });
};
export const useGenerateEan = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast("useGenerateEan");

  return useMutation<IGenerateEanResponse, DefaultError>({
    mutationKey: ["generate-ean"],
    mutationFn: async () => {
      loading(i18next.t("service-message.ean.loading"));

      const response = await apiClient({
        method: "PUT",
        url: `CodesDistributor/Ean/Read`,
      });

      return responseHandler(response, {
        groupName: `useGetEanCount`,
      });
    },
    onSuccess: (data: unknown) => {
      success(i18next.t("service-message.ean.success"));
    },
    onError: dismiss,
  });
};

export const useAddEans = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast("useGenerateEan");

  return useMutation<any, DefaultError, string[]>({
    mutationKey: ["add-ean"],
    mutationFn: async (eans) => {
      loading(i18next.t("service-message.add-ean.loading"));

      const response = await apiClient({
        method: "POST",
        url: `CodesDistributor/Ean/Add`,
        body: { eanList: eans },
      });

      return responseHandler(response, {
        groupName: `useGetEanCount`,
      });
    },
    onSuccess: (data) => {
      success(i18next.t("service-message.add-ean.success"));
    },
    onError: dismiss,
  });
};

export const useGetEanReport = (id: string, enabled?: boolean) => {
  const { responseStreamHandler } = useResponseHandler();

  return useQuery<Blob, DefaultError>({
    queryKey: ["ean-report"],
    async queryFn() {
      const response = await apiClient({
        method: "GET",
        url: `CodesDistributor/Ean/Report`,
      });

      return await responseStreamHandler(response);
    },
    enabled,
  });
};
